import tw from 'twin.macro';

export const subtitleStyle = tw`-mr-1.5 text-xs font-light`;
